const api = {
  base: process.env.VUE_APP_BASE_PATH,
  auth: {
    login: "/auth",
    logout: "/auth/session",
    forgotPassword: "/users/password/forgot",
    resetPassword: "/profile/default-password"
  },
  merchant: {
    list: "/business-merchant",
    upgrade: "/business-merchant/upgrade-account",
    detail: (merchantId) => `/business-merchant/${merchantId}`,
    apiKeyStatus: (merchantId) =>
      `/business-merchant/${merchantId}/apikey/status`,
    apiKeyActive: (merchantId) =>
      `/business-merchant/${merchantId}/apikey/active`,
    selfRegistration: "/business-merchant/self-register",
    resendVerification: (registerId) =>
      `/business-merchant/self-register/${registerId}/resend-verifycode`
  },
  banner: {
    list: "/promo-info",
    create: "/promo-info",
    detail: (id) => `/promo-info/${id}`,
    update: (id) => `/promo-info/${id}`,
    delete: (id) => `/promo-info/${id}`
  },
  profile: "/profile",
  master: {
    cities: "/master/cities",
    paymentMethods: "/master/payment_methods",
    goodsCategories: "/master/goods_categories",
    bankCodes: "/master/bank_codes",
    ownershipTypes: "/master/ownership_types",
    vehicleTypes: "/master/vehicle_types",
    driverLicenseTypes: "/master/driver_license_types",
    province: "/master/indonesia/provinces",
    district: (provinceId) =>
      `/master/indonesia/provinces/${provinceId}/districts`,
    subDistrict: (provinceId, districtId) =>
      `/master/indonesia/provinces/${provinceId}/districts/${districtId}/subdistricts`,
    urbanVillage: (provinceId, districtId, subDistrictId) =>
      `/master/indonesia/provinces/${provinceId}/districts/${districtId}/subdistricts/${subDistrictId}/urbanvillages`
  },
  image: {
    upload: "/images/upload"
  },
  admin: {
    list: "/admins",
    detail: (id) => `/admins/${id}`
  },
  awb: (awbNumber) => `/awb/${awbNumber}`,
  armada: {
    list: (partnerId) => `/partners/${partnerId}/vehicles`,
    detail: (partnerId, vehicleId) =>
      `/partners/${partnerId}/vehicles/${vehicleId}`,
    history: (partnerId, vehicleId) =>
      `/partners/${partnerId}/vehicles/${vehicleId}/drivers`,
    partner: (partnerId) => `/partners/${partnerId}/vehicle-partners`,
    partnerDetail: (partnerId, vehiclePartnerId) =>
      `/partners/${partnerId}/vehicle-partners/${vehiclePartnerId}`,
    partnerVehicle: (partnerId, vehiclePartnerId) =>
      `/partners/${partnerId}/vehicle-partners/${vehiclePartnerId}/vehicles`
  },
  order: {
    list: "/orders",
    detail: (orderId) => `/orders/${orderId}`,
    processOrder: (orderId) => `/orders/${orderId}/proceed`,
    rejectOrder: (orderId) => `/orders/${orderId}/reject`,
    updateShipment: (orderId) => `/orders/${orderId}/update`,
    insufficientPayment: "/orders/new-charged",
    insufficientPaymentDetail: (orderId) => `/orders/new-charged/${orderId}`,
    paymentConfirm: (orderId) =>
      `/orders/new-charged/${orderId}/payment-confirm`,
    cancel: (orderId) => `/orders/${orderId}/cancel`,
    priceAdjustments: "/orders/price-adjustments",
    completePriceAdjustment: (orderId) =>
      `/orders/${orderId}/price-adjustment/complete`,
    rejectPriceAdjustment: (orderId) =>
      `/orders/${orderId}/price-adjustment/reject`,
    retryShipment: (orderId) => `/orders/${orderId}/retry-shipment`
  },
  courier: {
    list: "/couriers",
    detail: (courierId) => `/couriers/${courierId}`,
    balance: "/couriers/balance"
  },
  hub: {
    list: (partnerId) => `/partners/${partnerId}/logistic-hubs`,
    detail: (partnerId, hubId) =>
      `/partners/${partnerId}/logistic-hubs/${hubId}`
  },
  assignment: {
    pickup: `/pickup-assignments`,
    pickupDetail: (pickupId) => `/pickup-assignments/${pickupId}`,
    nearByCouriers: (pickupId) =>
      `/pickup-assignments/${pickupId}/couriers/nearby`,
    assignCourier: (pickupId) =>
      `/pickup-assignments/${pickupId}/couriers/assign`,
    driver: (partnerId) => `/partners/${partnerId}/vehicles/driver-assignments`
  },
  summary: {
    paymentReports: "/report/transactions",
    paymentReportsDownload: "/report/transactions/download"
  },
  partner: {
    list: "/partners",
    detail: (id) => `/partners/${id}`,
    updateStatus: (id) => `/partners/${id}/update_status`,
    type: "/partner/types",
    package: (id) => `/partners/${id}/packages`,
    packageDetail: (partnerId, packageId) =>
      `/partners/${partnerId}/packages/${packageId}`,
    costMapping: (partnerId) => `/partners/${partnerId}/cost_mappings`,
    costMappingDetail: (partnerId, costMappingId) =>
      `/partners/${partnerId}/cost_mappings/${costMappingId}`,
    duplicateCostMapping: (partnerId, costMappingId) =>
      `/partners/${partnerId}/cost_mappings/${costMappingId}/duplicate`,
    baseCost: (partnerId, costMappingId) =>
      `/partners/${partnerId}/cost_mappings/${costMappingId}/base_costs`,
    baseCostDetail: (partnerId, costMappingId, baseCostId) =>
      `/partners/${partnerId}/cost_mappings/${costMappingId}/base_costs/${baseCostId}`,
    vehicle: (partnerId) => `/partners/${partnerId}/vehicle-partners`,
    deliveryServices: `/delivery-services`,
    logos: "/partner-logos",
    selfRegistration: "/logistic/partner/registration"
  },
  role: {
    permissionList: "/permissions",
    roles: "/roles",
    roleDetail: (id) => `/roles/${id}`
  },
  invoice: {
    merchantOrderList: "/invoice/merchant-list",
    invoiceList: "/invoice/invoice-list",
    orderList: "/invoice/order-list",
    generateInvoice: "/invoice/generate-invoice",
    paid: "/invoice/paid"
  },
  invoiceGenerator: {
    customers: "/invoice-generator/customers",
    customerDetail: (customerId) => `/invoice-generator/customers/${customerId}`,
    customerPrices: "/invoice-generator/customer-prices",
    customerPriceDetail: (priceId) =>
      `/invoice-generator/customer-prices/${priceId}`,
    customerPriceOptions: "/invoice-generator/customer-prices/options",
    customerPriceDestinations: "/invoice-generator/customer-prices/destinations",
    resi: "/invoice-generator/resi",
    resiDetail: (resiId) => `/invoice-generator/resi/${resiId}`,
    resiPackages: (resiId) => `/invoice-generator/resi/${resiId}/packages`,
    packageDetail: (packageId) => `/invoice-generator/packages/${packageId}`,
    invoices: "/invoice-generator/invoices",
    invoiceDetail: (invoiceId) => `/invoice-generator/invoices/${invoiceId}`,
    invoicePdf: (invoiceId) => `/invoice-generator/invoices/${invoiceId}/pdf`
  },
  notification: {
    notif: "/notifications/notif-blast"
  },
  article: {
    list: "/article",
    detail: (id) => `/article/${id}`,
    create: "/article",
    update: (id) => `/article/${id}`,
    delete: (id) => `/article/${id}`
  },
  promo: {
    list: "/promo",
    create: "/promo",
    detail: (id) => `/promo/${id}`
  },
  voucher: {
    list: "/voucher",
    create: "/voucher",
    detail: (id) => `/voucher/${id}`
  },
  deliveryService: {
    packages: (id) => `/delivery-services/package/${id}`
  },
  career: {
    list: "/careers",
    detail: (id) => `/careers/${id}`,
    create: "/careers",
    update: (id) => `/careers/${id}`,
    delete: (id) => `/careers/${id}`,
    submissions: "/career-submissions",
    submissionDetail: (id) => `/career-submissions/${id}`,
    updateSubmissionStatus: (id) => `/career-submissions/${id}/status`,
    deleteSubmission: (id) => `/career-submissions/${id}`,
    careerSubmissions: (careerId) => `/careers/${careerId}/submissions`
  },
  smesco: {
    feeSettings: "/mitra-fee-settings",
    feeSettingDetail: (id) => `/mitra-fee-settings/${id}`,
    revenues: "/mitra-revenue",
    revenueDetail: (id) => `/mitra-revenue/${id}`,
    revenueApprove: (id) => `/mitra-revenue/${id}/approve`
  },
  instantDelivery: {
    list: "/instant-deliveries"
  }
}

export default api
